<script>
	import InfoContent from './InfoContent.svelte';
	import { _ } from 'svelte-i18n';

	export let scrollToTop = () => {window.scrollTo({top: 0, left: 0, behavior: 'smooth'})};
</script>

<style>
	.info-section {
		background-color: var(--colorBgVariant);
        padding: var(--spacingXXLarge);
	}

	.learn-title {
		position: relative;
	}

	.back-to-top {
		position: absolute;
		right: 30px;
		top: 10px;
		width: 30px;
	}

	.info-content {
		display: flex;
		max-width: 900px;
		justify-content: space-between;
		flex-wrap: wrap;
		margin: auto;
	}

	h1 {
		margin-bottom: var(--spacingXLarge);
	}

	.read-more {
		font-weight: 800;
		text-decoration: underline;
	}
	.read-more:hover {
		color: var(--colorElementVariant);
	}

	@media screen and (max-width: 374px) {
		.back-to-top {
			width: 20px;
			top: 7px;
		}
		h1 {
			font-size: 1.5em;
		}
	}
</style>

<div class="info-section" id="learn">
	<div class="learn-title">
		<img alt="back to top" class="back-to-top" src="img/arrow-up.svg" on:click={scrollToTop} />
		<h1>{$_('learn.title')}</h1>
		<div class="info-content">
			<InfoContent to="/muskelstyrka-matning" bg_img="/img/knaext.png">{$_('learn.infopage_1.link')} <span class="read-more">{$_('learn.read_more')}</span></InfoContent>
			<InfoContent to="/tabell-utgangsstallningar" bg_img="/img/table_small.png">{$_('learn.infopage_2.link')} <span class="read-more">{$_('learn.read_more')}</span></InfoContent>
			<InfoContent to="/filmer-matning" bg_img="/img/hoftext2.png">{$_('learn.infopage_3.link')} <span class="read-more">{$_('learn.read_more')}</span></InfoContent>
		</div>
	</div>

</div>